<template lang="pug">
div
  v-row( dense align="center" justify="space-between" )
    v-col( cols="6" )
      v-btn.goal-btn.text-14( block depressed :class="{ active: !hasDeadline }" @click="setNoDeadline" )
        | Без срока
    v-col(cols="6")
      v-btn.goal-btn.text-14( block depressed :class="{ active: hasDeadline }" @click="openDatePicker" )
        | Выбрать дату
  v-dialog( v-model="dateDialog" max-width="320" )
    div.date-dialog
      v-date-picker( v-model="selectedDate" scrollable locale="ru" :min="today" @input="saveDate" )
      v-card-actions
        v-spacer
        v-btn( text color="grey" @click="closeDialog" ) Отмена
        v-btn( text color="primary" @click="confirmDate" ) OK

  span.text-12.remainder Осталось {{ daysLeftText }}
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      hasDeadline: false,
      deadline: null,
      selectedDate: null,
      dateDialog: false,
      today: new Date().toISOString().substr(0, 10)
    };
  },

  mounted() {
    if(this.selectedGoal.completed_date && this.selectedGoal.completed_date != '' && this.selectedGoal.completed_date != 'Без срока') {
      this.hasDeadline = true;
      this.selectedDate = this.selectedGoal.completed_date.split('-').reverse().join('-')
      this.deadline = this.selectedDate
    } else this.$emit('chooseDeadline', 'Без срока')
    
  },

  computed: {
    ...mapState('goals', ['selectedGoal']),
    daysLeftText() {
      if (!this.deadline) return 'X дней';
      const diff = Math.ceil((new Date(this.deadline) - new Date()) / (1000 * 60 * 60 * 24));
      return diff > 0 ? `${diff} дней` : 'цель достигнута!';
    },
  },

  methods: {
    setNoDeadline() {
      this.hasDeadline = false;
      this.deadline = null;
      this.$emit('chooseDeadline', 'Без срока')
    },

    openDatePicker() {
      this.hasDeadline = true;
      this.dateDialog = true
    },

    saveDate(val) {
      this.selectedDate = val
    },

    closeDialog() {
      this.dateDialog = false;
      this.selectedDate = null;
    },

    confirmDate() {
      if(this.selectedDate) {
        this.deadline = this.selectedDate;
        this.dateDialog = false;
        this.$emit('chooseDeadline', this.selectedDate.split('-').reverse().join('-'))
      } else {
        this.hasDeadline = false
        this.dateDialog = false 
        this.$emit('chooseDeadline', 'Без срока')
      }
    },
  },
};
</script>

<style scoped>
.goal-btn {
  background: #E5E7EB;
  border-radius: 6px;
  text-transform: none;
  height: 36px;
}
.goal-btn.active {
  background-color: #b8d1ff !important;
  color: black;
}
.remainder {
  color: #727272;
}
.date-dialog {
  background-color: white;
}
</style>
